import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  LinearProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdDownload, MdPayment } from "react-icons/md";

import CustomInputLogin from "../../../../Components/CustomInputLogin/CustomInputLogin";
import "../../../ContentManagement/Home/Modal/BannerinputGetModal.css"; // Import external CSS
import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import { FiUpload } from "react-icons/fi";

import CustoDropDownRegister from "../../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDropdownDocumentType from "../../../../Components/CustomDropDown/CustomDropdownDocumentType";

import CustomEmailVerifyInput from "../../../../Components/CustomInput/CustomEmailVerifyInput/CustomEmailVerifyInput";
import CustomPhoneVerifyInput from "../../../../Components/CustomInput/CustomMobileNumber/CustomMobileNumber";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../ReduxStore/actions";
import { HiDocumentArrowUp } from "react-icons/hi2";
import { RiDeleteBin2Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import { setCustomerId } from "../../../../ReduxStore/Slices/Operator/customerSlice";
import { adminUrl } from "../../../../constants";
import { AiOutlineEye, AiOutlineProfile } from "react-icons/ai";
import WarningModal from "../../../OperatorRegistration/Modal/WarningModal";
// import { MdCancel } from "react-icons/md";

const validationSchema = Yup.object({
  first_name: Yup.string().required("First Name is required"),
  type: Yup.string().required("Type is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),

  isVerified: Yup.boolean().oneOf(
    [true],
    "Please verify your OTP before submitting"
  ),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Phone number is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    )
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),

  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  zip_code: Yup.string().required("Zipcode is required"),
  address_1: Yup.string().required("Address Line 1 is required"),
  address_2: Yup.string().required("Address Line 2 is required"),
});

const AllUserListEditModal = ({
  open,
  onClose,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  // editData
  editData
}) => {
  // const [uploadedFile, setUploadedFile] = useState(null);
  // console.log(editData.image,"EditDatatattaatatt")
  const [uploadedFiles, setUploadedFiles] = useState([]);
  // console.log(uploadedFiles,"uploaddfjsfd")
  const [selectedDocumentType, setSelectedDocumentType] = React.useState("");
  const [isRegisterCompleteModalOpen, setRegisterCompleteModalOpen] =
    useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [emailInput, setEmailInput] = useState(""); // Track email input

  const [phoneInput, setPhoneInput] = useState(""); // Track phone number input
  const [isVerified, setIsVerified] = useState(false);

  const [checked, setChecked] = useState(false);

  const handleCheckChange = (isChecked) => {
    setChecked(isChecked);
  };

  // const [selectedDocumentType, setSelectedDocumentType] = React.useState('');
  // const [uploadedFiles, setUploadedFiles] = React.useState([]);
  const [documentTypeDropData, setDocumentTypeDropData] = React.useState([]);
  const dispatch = useDispatch();

  console.log(uploadedFiles, "uploaded fileee");

  const { getKYCByCountry } = useSelector((state) => state?.getKYCByCountry);

  const [formValues, setFormValues] = useState({
    first_name: "",
    type: "",
    email: "",
    isVerified: false,
    phone: "",
    password: "",
    confirmPassword: "",
    country: "",
    state: "",
    city: "",
    zip_code: "",
    address_1: "",
    address_2: "",
  });

  useEffect(() => {
    if (editData) {
      setFormValues({
        first_name: editData.first_name || "",
        type: editData.type || "",
        email: editData.email || "",
        isVerified: editData.isVerified || false,
        isEmailVerified: editData.isVerified || false,

        phone: editData.phone || "",
        password: "",
        confirmPassword: "",
        country: editData.country || "",
        state: editData.state || "",
        city: editData.city || "",
        zip_code: editData.zip_code || "",
        address_1: editData.address_1 || "",
        address_2: editData.address_2 || "",
      });
      setUploadedFiles(editData.image)
    } else {
      setFormValues({
        first_name: "",
        type: "",
        email: "",
        isVerified: false,
        phone: "",
        password: "",
        confirmPassword: "",
        country: "",
        state: "",
        city: "",
        zip_code: "",
        address_1: "",
        address_2: "",
      });
    }
  }, [editData, open]);

  // Ensure documentTypeDropData is set once getKYCByCountry is updated
  useEffect(() => {
    if (getKYCByCountry?.data?.kycs) {
      setDocumentTypeDropData(getKYCByCountry.data.kycs);
    }
  }, [getKYCByCountry]);

  const options = documentTypeDropData.map((item) => ({
    label: item,
    value: item,
  }));

  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const handleWarningOpenModal = () => {
    setWarningModalOpen(true);
  };

  const handleWarningCloseModal = () => {
    setWarningModalOpen(false);
  };

  useEffect(() => {
    const data1 = {
      data: {},
      method: "get",
      apiName: "getKYCByCountry/1",
    };

    dispatch(actions.GETKYCBYCOUNTRY(data1));
  }, [dispatch]);

  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   console.log(file, "filesssss");
  //   if (file) {
  //     setUploadedFiles((prevFiles) => [
  //       ...prevFiles,
  //       { name: file.name, type: selectedDocumentType, progress: 100 },
  //     ]);
  //     console.log(uploadedFiles, "filesssss");
  //   }
  // };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    console.log(file, "filefilefilefile");

    if (file) {
      const formData = new FormData();

      // Append the file to the FormData object
      formData.append("uploadFile", file);

      const data1 = {
        data: formData,
        method: "post",
        apiName: "uploadPdfAndImage",
      };

      const uploadPdfAndImageResponse = await dispatch(
        actions.UPLOADPDFANDIMAGE(data1)
      );

      // console.log(uploadPdfAndImageResponse.payload.data.fileUrl,"formData12121")

      setUploadedFiles((prevFiles) => [
        ...prevFiles,
        {
          fileUrl: uploadPdfAndImageResponse?.payload?.data?.fileUrl,
          type: selectedDocumentType,
          progress: 100,
        },
      ]);

      console.log(uploadedFiles, "uploadedFilesuploadedFilesuploadedFiles");
    }
  };

  const handleFileDelete = (index) => {
    setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // const handleRegisterCompleteOpenModal = () => {
  //     onClose(); // Close Modal1
  //     setTimeout(() => {
  //         setRegisterCompleteModalOpen(true); // Open Modal2
  //     }, 200); // Delay for smooth transition
  // };

  const handleCloseCloseModal = () => {
    // setRegisterCompleteModalOpen(false);
    setIsVerified(false);
    setIsEmailVerified(false);
    setEmailInput("");
    setPhoneInput("");
    setUploadedFiles([]);
    onClose();
  };

  const handleCancelModal = () => {
    // setRegisterCompleteModalOpen(false);
    setIsVerified(false);
    setIsEmailVerified(false);
    setEmailInput("");
    setPhoneInput("");
    setUploadedFiles([]);
    onClose();
  };

  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );
  // const { ImageUploadPost } = useSelector((state) => state?.ImageUploadPost);

  console.log(managementRegisterForCustomer, "managementRegisterForCustomer");
  const customerId = useSelector((state) => state.customer.customerId);

  const [
    managementRegisterForCustomerData,
    setManagementRegisterForCustomerData,
  ] = useState(null);

  const regiterFormSubmitionFn = async (values, uploadedFiles) => {
    console.log(values, "values 123456");
    console.log(uploadedFiles, "values 123456111");
    console.log("hii this is submit function Work");
    if (uploadedFiles.length !== 0) {
      const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
      const UserRole = sessionStorage.getItem("UserRole");
      const data1 = {
        data: {
          ...values,

          userId: sessionOperator_id,
          userRole: UserRole,
          kycPdf: uploadedFiles,
          // kycPdf: [
          //   {
          //     type: "Aadhaar",
          //     fileUrl: "https://example.com/kyc/aadhaar.pdf",
          //   },
          //   {
          //     type: "PAN",
          //     fileUrl: "https://example.com/kyc/pan.pdf",
          //   },
          // ],
        },
        method: "post",
        apiName: "managementRegisterForCustomer",
      };

      const result = await dispatch(
        actions.MANAGEMENTREGISTERFORCUSTOMER(data1)
      );
      setManagementRegisterForCustomerData(result); // Set the state here/
    } else {
      handleWarningOpenModal();
    }
  };

  console.log(
    managementRegisterForCustomer?.payload,
    "managementRegisterForCustomer...payload?"
  );

  useEffect(() => {
    if (
      managementRegisterForCustomerData?.payload?.message ===
      "Customer registered successfully."
    ) {
      console.log("workingallala");
      toast.success("Registered successfully");
      // sessionStorage.setItem("sessioncustomer_id", customerRegisterData?.payload?.data.customer_id);
      // sessionStorage.setItem("sessionFirstName", customerRegisterData?.payload?.data.first_name);
      dispatch(
        setCustomerId(
          managementRegisterForCustomerData?.payload?.data?.customer_id
        )
      ); // Example ID

      setIsVerified(false);
      setIsEmailVerified(false);
      setEmailInput("");
      setPhoneInput("");
      setUploadedFiles([]);
      setTimeout(() => {
        handleNextModal();
      }, 2500);
    } else {
      console.log(
        managementRegisterForCustomerData?.payload?.message,
        "hiiiiiiiiiiiiiiiiiiiiiiiiiiii"
      );
      toast.error(managementRegisterForCustomerData?.payload?.message);
    }
  }, [managementRegisterForCustomerData]); // This effect will run when customerRegister changes

  const [previewFile, setPreviewFile] = useState(null);
  console.log(previewFile, "previewFilepreviewFile");

  const handlePreview = (file) => {
    setPreviewFile(file);
  };

  const handleDownload = (file) => {
    console.log(file, "fileeeeeeeeeeee");

    if (!file) return;

    if (file instanceof Blob) {
      // If file is a Blob, create an object URL
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name || "downloaded-file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else if (typeof file === "string") {
      // If file is a URL, download directly
      const a = document.createElement("a");
      a.href = `${adminUrl}${file}`;
      a.download = file.split("/").pop(); // Extract filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleClosePreview = () => {
    setPreviewFile(null);
  };
  return (
    <Dialog
      open={open}
      // onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        // maxWidth: "700px",
        // margin: "auto",
        "& .MuiPaper-root": {
          borderRadius: "14px", // Target the Paper component
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={handleCloseCloseModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                {modalHeadingName}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>

        <Formik
          // initialValues={{
          //   first_name: "",
          //   last_name: "",
          //   type: "",
          //   referred_by: "",
          //   email: "",
          //   phone: "",
          //   isVerified: false,
          //   password: "",
          //   confirmPassword: "",
          //   countrycode: "",

          //   country: "",
          //   state: "",
          //   city: "",
          //   zip_code: "",
          //   address_1: "",
          //   address_2: "",
          //   // profileImage: "",
          // }}
          // validationSchema={validationSchema}
          // onSubmit={(values, { resetForm }) => {
          //   console.log(values, "Form values submitted");
          //   // handleRegisterCompleteOpenModal(); // Open the RegistrationCompleteModal
          //   regiterFormSubmitionFn(values, uploadedFiles);
          //   // handleSubmit();
          //   // resetForm();
          // }}

          initialValues={formValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values) => {
            console.log("Submitted values:", values);
            if (editData) {
              // Call update API
              console.log("Updating user...");
            } else {
              // Call create API
              console.log("Creating new user...");
            }
          }}
        >
          {({ handleSubmit, setFieldValue, resetForm, values }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* Title and Subtitle on the left, Content on the right */}
                  <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="First Name"
                          name="first_name"
                          inputType="text"
                          custPlaceholder="Enter First Name"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Last Name"
                          name="last_name"
                          inputType="text"
                          custPlaceholder="Enter Last Name"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustoDropDownRegister
                          important={true}
                          name="type"
                          label="User Type"
                          custPlaceholder="Select Type"
                          options={[
                            { label: "Individual", value: "Individual" },
                            { label: "Institutional", value: "Institutional" },
                          ]}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomEmailVerifyInput
                          important={true}
                          setIsVerified={setIsEmailVerified}
                          isVerified={isEmailVerified}
                          emailInput={emailInput}
                          setEmailInput={setEmailInput}
                          name="email"
                          label="Email ID"
                          inputType="email"
                          setFieldValue={setFieldValue}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomPhoneVerifyInput
                          important={true}
                          name="phone"
                          label="Mobile Number"
                          countrycodename="countrycode"
                          setIsVerified={setIsVerified}
                          isVerified={isVerified}
                          phoneInput={phoneInput}
                          setPhoneInput={setPhoneInput}
                          custPlaceholder="Enter Mobile Number"
                          setFieldValue={setFieldValue} // Pass setFieldValue to CustomPhoneVerifyInput
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Referral Code"
                          name="referred_by"
                          inputType="text"
                          custPlaceholder="Enter Referral Code"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Address Line 1"
                          name="address_1"
                          inputType="text"
                          custPlaceholder="Enter Address Line 1"
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Address Line 2"
                          name="address_2"
                          inputType="text"
                          custPlaceholder="Enter Address Line 2"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="City"
                          name="city"
                          inputType="text"
                          custPlaceholder="Enter City"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="State"
                          name="state"
                          inputType="text"
                          custPlaceholder="Enter State"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Country"
                          name="country"
                          inputType="text"
                          custPlaceholder="Enter Country"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Zipcode"
                          name="zip_code"
                          inputType="number"
                          custPlaceholder="Enter ZipCode"
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          important={true}
                          name="password"
                          label="Password"
                          inputType="password"
                          custPlaceholder="Enter Password"
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          important={true}
                          name="confirmPassword"
                          label="Confirm Password"
                          inputType="password"
                          custPlaceholder="Re-Enter Password"
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <CustomDropdownDocumentType
                          name="emiratesid"
                          label="Document Type"
                          custPlaceholder="select a type"
                          setFieldValue={setFieldValue}
                          selectedDocumentType={selectedDocumentType}
                          setSelectedDocumentType={setSelectedDocumentType}
                          options={options}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <>
                          {/* Documents Section (Step 3) */}
                          <Grid
                            container
                            spacing={4}
                            // mt="1px"
                            pt={2}
                          >
                            <Grid item xs={12}>
                              {/* File Upload Button */}
                              <label
                                htmlFor="file-upload"
                                style={{
                                  fontSize: "16px",
                                  marginBottom: "6px",
                                }}
                              >
                                Upload Files{" "}
                                <span
                                  style={{ fontSize: "11px", color: "#7A7A7A" }}
                                >
                                  (Files supported: .png, .jpg, .pdf)
                                </span>
                              </label>
                              <input
                                accept=".png,.jpg,.pdf"
                                style={{ display: "none" }}
                                id="file-upload"
                                type="file"
                                // name=""
                                onChange={handleFileUpload}
                                multiple
                              />
                              <label
                                htmlFor="file-upload"
                                style={{ marginTop: "10px" }}
                              >
                                <Button
                                  component="span"
                                  startIcon={
                                    <FiUpload style={{ fontSize: "14px" }} />
                                  }
                                  sx={{
                                    width: "100%",
                                    color: "white",
                                    background: "#252525",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    textTransform: "none",
                                  }}
                                >
                                  Browse
                                </Button>
                              </label>

                              {/* {uploadedFiles.length > 0
                                ? uploadedFiles.map((file, index) => (
                                    <Grid item xs={12} key={index}>
                                      <Paper
                                        elevation={3}
                                        style={{
                                          paddingBottom: "5px",
                                          paddingRight: "5px",
                                          paddingLeft: "5px",

                                          background: "#F7F7F7",
                                          border: "none",
                                          boxShadow: "none",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <HiDocumentArrowUp
                                            style={{
                                              fontSize: "30px",
                                              color: "#C38F51",
                                              marginRight: "10px",
                                            }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{
                                            width: "-webkit-fill-available",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{ fontWeight: "800px" }}
                                            >
                                              {file.type}
                                            </Typography>
                                            <IconButton
                                              onClick={() =>
                                                handleFileDelete(index)
                                              }
                                              sx={{
                                                color: "black",
                                                background: "none",
                                                "&:hover": {
                                                  color: "red",
                                                  background: "none",
                                                },
                                              }}
                                            >
                                              <RiDeleteBin2Line
                                                style={{
                                                  fontSize: "14px",
                                                  fontWeight: "800",
                                                }}
                                              />
                                            </IconButton>
                                          </Box>
                                          <LinearProgress
                                            variant="determinate"
                                            value={file.progress}
                                            sx={{
                                              height: "6px",
                                              borderRadius: "10px",
                                              backgroundColor: "lightgray",
                                              "& .MuiLinearProgress-bar": {
                                                backgroundColor:
                                                  file.progress === 100
                                                    ? "#1FC45B"
                                                    : "red",
                                              },
                                            }}
                                          />
                                          <Box
                                            display="flex"
                                            justifyContent="space-between"
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{
                                                fontSize: "12px",
                                                color: "gray",
                                              }}
                                            >
                                              {file.name}
                                            </Typography>
                                            <Typography
                                              variant="body1"
                                              fontSize="12px"
                                              color={
                                                file.progress === 100
                                                  ? "green"
                                                  : "red"
                                              }
                                            >
                                              {file.progress === 100
                                                ? "Upload Successful!"
                                                : `${file.progress}%`}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      </Paper>
                                    </Grid>
                                  ))
                                : null} */}
                              <Grid>
                                {uploadedFiles.length > 0 ? (
                                  uploadedFiles.map((file, index) => (
                                    <Grid item xs={12} key={index}>
                                      <Paper
                                        elevation={3}
                                        style={{
                                          padding: "5px",
                                          background: "#F7F7F7",
                                          boxShadow: "none",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <HiDocumentArrowUp
                                            style={{
                                              fontSize: "30px",
                                              color: "#C38F51",
                                              marginRight: "10px",
                                            }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{
                                            width: "-webkit-fill-available",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{ fontWeight: "800px" }}
                                            >
                                              {file.type}
                                            </Typography>
                                            <Box>
                                              <IconButton
                                                onClick={() =>
                                                  handlePreview(file.fileUrl)
                                                }
                                                sx={{
                                                  color: "black",
                                                  "&:hover": { color: "blue" },
                                                }}
                                              >
                                                <AiOutlineEye
                                                  style={{ fontSize: "16px" }}
                                                />
                                              </IconButton>

                                              <IconButton
                                                onClick={() =>
                                                  handleDownload(file.fileUrl)
                                                }
                                                sx={{
                                                  color: "black",
                                                  "&:hover": { color: "blue" },
                                                }}
                                              >
                                                <MdDownload
                                                  style={{ fontSize: "16px" }}
                                                />
                                              </IconButton>

                                              <IconButton
                                                onClick={() =>
                                                  handleFileDelete(index)
                                                }
                                                sx={{
                                                  color: "black",
                                                  "&:hover": { color: "red" },
                                                }}
                                              >
                                                <RiDeleteBin2Line
                                                  style={{ fontSize: "14px" }}
                                                />
                                              </IconButton>
                                            </Box>
                                          </Box>
                                          <LinearProgress
                                            variant="determinate"
                                            value={file.progress}
                                            sx={{
                                              height: "6px",
                                              borderRadius: "10px",
                                              backgroundColor: "lightgray",
                                              "& .MuiLinearProgress-bar": {
                                                backgroundColor:
                                                  file.progress === 100
                                                    ? "#1FC45B"
                                                    : "red",
                                              },
                                            }}
                                          />
                                          <Box
                                            display="flex"
                                            justifyContent="space-between"
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{
                                                fontSize: "12px",
                                                color: "gray",
                                              }}
                                            >
                                              {file.name}
                                            </Typography>
                                            <Typography
                                              variant="body1"
                                              fontSize="12px"
                                              color={
                                                file.progress === 100
                                                  ? "green"
                                                  : "red"
                                              }
                                            >
                                              {file.progress === 100
                                                ? "Upload Successful!"
                                                : `${file.progress}%`}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      </Paper>
                                    </Grid>
                                  ))
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        textAlign: "center",
                                        color: "#E5E5E5",
                                      }}
                                    >
                                      <AiOutlineProfile
                                        style={{ fontSize: "100px" }}
                                      />
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          color: "#E5E5E5",
                                          textAlign: "center",
                                        }}
                                      >
                                        No uploads available.
                                      </Typography>
                                    </Box>
                                  </>
                                )}

                                {/* Preview Modal */}
                                <Dialog
                                  open={Boolean(previewFile)}
                                  // onClose={handleClosePreview}
                                  fullWidth
                                  maxWidth="md"
                                  className="custom-dialog"
                                  sx={{
                                    "& .MuiPaper-root": {
                                      maxWidth: "800px",
                                      // borderRadius: "14px",
                                    },
                                  }}
                                >
                                  <IconButton
                                    aria-label="Close"
                                    onClick={handleClosePreview}
                                    sx={{
                                      position: "absolute",
                                      top: 8,
                                      right: 8,
                                      color: "white",
                                    }}
                                  >
                                    <MdCancel />
                                  </IconButton>
                                  <Box>
                                    {previewFile &&
                                      (previewFile.includes(
                                        "uploads/images/"
                                      ) ? (
                                        <img
                                          src={`${adminUrl}${previewFile}`}
                                          alt="Preview"
                                          style={{ width: "100%" }}
                                        />
                                      ) : previewFile.includes(
                                          "uploads/pdfs/"
                                        ) ? (
                                        <iframe
                                          src={`${adminUrl}${previewFile}`}
                                          title="PDF Preview"
                                          width="100%"
                                          height="500px"
                                        />
                                      ) : null)}

                                    {/* <img
                                    src={`${adminUrl}${previewFile}`}
                                    // alt={previewFile.name}
                                    style={{ width: "100%" }}
                                  />
                                  ) : previewFile?.type.includes("pdf") ? (
                                  <iframe
                                    // src={previewFile.url}

                                    src={`${adminUrl}${previewFile}`}
                                    width="100%"
                                    height="500px"
                                    title={previewFile.name}
                                  />
                                  ) : (
                                  <Typography>
                                    Preview not available.
                                  </Typography>
                                  )} */}
                                  </Box>
                                </Dialog>
                              </Grid>
                            </Grid>
                            {/* </Grid> */}

                            {/* <Typography>I accept all the Terms & Conditions and Privacy Policies of goldstake.com</Typography> */}
                          </Grid>
                        </>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                {/* <DialogActions> */}
                <Grid sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
                  <Grid>
                    <Button
                      onClick={() => {
                        // resetForm();
                        handleCancelModal();
                      }}
                      variant="text"
                      // className="custom-clear-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        mr: "10px",
                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "white",
                        boxShadow: "none",
                        color: "black",
                        border: "1px solid black",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          color: "white",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      // className="custom-ok-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        boxShadow: "none",

                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "#C38F51 0% 0% no-repeat padding-box",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>

              {/* </DialogActions> */}
            </Form>
          )}
        </Formik>
        <ToastContainer
          position="top-right" // or "top-center", "bottom-left", etc.
          autoClose={1500} // Auto close duration in ms
          hideProgressBar={false} // Hide or show progress bar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <WarningModal
          open={isWarningModalOpen}
          onClose={handleWarningCloseModal}
        />
      </Box>
      {/* <RegistrationCompleteModal open={isRegisterCompleteModalOpen} onClose={handleRegisterCompleteCloseModal} modalViewHeadingName="Register Complete" /> */}
    </Dialog>
  );
};

export default AllUserListEditModal;
